import { createContext, useContext, useEffect, useState } from "react";

const OfferContext = createContext(null);

export function OfferProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("oxo_offer") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("oxo_offer", JSON.stringify(items));
  }, [items]);

  const has = (id) => items.some((i) => i.id === id);

  const add = (product) =>
    setItems((prev) =>
      prev.some((i) => i.id === product.id)
        ? prev
        : [...prev, {
            id: product.id, name: product.name, brand: product.brand || "",
            price: product.price, price_eur: product.price_eur,
            image: product.image, specs: product.specs || {},
          }]
    );

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const toggle = (product) => (has(product.id) ? remove(product.id) : add(product));
  const clear = () => setItems([]);

  const count = items.length;
  const total = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <OfferContext.Provider value={{ items, add, remove, toggle, has, clear, count, total }}>
      {children}
    </OfferContext.Provider>
  );
}

export const useOffer = () => useContext(OfferContext);
